import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 근무코드의 선택 여부 — 병원별로 기억한다 */
export type StoredWorkCode = {
    _id: string
    isSelected: boolean
}

export type V2WorkCodeState = {
    hospitals: Record<string, StoredWorkCode[] | undefined>
}

const state: V2WorkCodeState = {
    hospitals: {},
}

type WorkCodeParam = { hospitalID: string; codes: StoredWorkCode[] }

const mutations = {
    'MU_V2WorkCode_Set': (state: V2WorkCodeState, param: WorkCodeParam): void => {
        const hospitalID = param.hospitalID
        state.hospitals[hospitalID] = param.codes.map((c) => ({
            _id: c._id,
            isSelected: c.isSelected,
        }))
    },
    /** 기억해 둔 것만 갈아끼운다 — 처음 보는 코드는 무시한다(Set 이 먼저 채운다) */
    'MU_V2WorkCode_Update': (state: V2WorkCodeState, param: WorkCodeParam): void => {
        const hospitalID = param.hospitalID
        const codes = param.codes
        const origins = state.hospitals[hospitalID] ?? []
        for (let i = 0; i < codes.length; i++) {
            const code = codes[i]
            const origin = origins.find((c) => c._id == code._id)
            if (origin == undefined) { continue }
            const index = origins.indexOf(origin)
            origins[index].isSelected = code.isSelected
        }
        state.hospitals[hospitalID] = origins
    },
}

const V2WorkCode: Module<V2WorkCodeState, StoreState> = { state, mutations }

export default V2WorkCode
